<template>
  <div class="mm-page-main"  v-loading="mso_id==0" :element-loading-text="'請先添加牌照MSO和門店'" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.6)">
    <div class="page-header">
      <div class="page-title">匯率管理</div>

    </div>

    <div v-if="stores.length>0" class="mm-tabs">
      <div class="mm-tabsulbox">
        <div @click="tableft" class="tabsleftico"><i class="el-icon-arrow-left"></i></div>
        <ul :style="transform" class="mm-tabs-card">
          <li @click.stop="changestore(store.id)" :class="{active:store_id == store.id}" v-for="(store,index) in stores" :key="index">{{store.short}} {{store.name}}</li>
        </ul>
        <div @click="tabright" class="tabsrightico"><i class="el-icon-arrow-right"></i></div>
      </div>
      <div class="mm-tabs-content">
        <div class="mm-tab-hedaer">
          <div class="mm-tab-title">
            <h3>現金</h3>
          </div>

        </div>
        <div class="pagetablebox">
          <el-table empty-text="暫無數據" :data="ratedata0" border :header-cell-style="{background:'#FAFAFA'}">
            <el-table-column prop="name" label="貨幣" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">貨幣</div>
                <div style="display: flex; align-items: center; ">
                  <div><img style="display: block; width: 30px; height: 30px;" :src="apiurl+scope.row.thumb"></div>
                  <div style="margin-left: 10px;">{{scope.row.short_name}}</div>
                  <div style="margin-left: 10px;">{{scope.row.name}}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="buyrate" label="買入" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">買入</div>
                <span>{{scope.row.buyrate}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="sellrate" label="賣出" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">賣出</div>
                <span>{{scope.row.sellrate}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="costrate" label="成本" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">成本</div>
                <span>{{scope.row.costrate}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="fee" label="手續費" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">手續費</div>
                <div>
                  <span>{{scope.row.fee}}</span>
                  <span style="margin-left:10px" v-if="scope.row.fee!=''&&scope.row.fee!=null">{{scope.row.fee_type==1?'HKD':scope.row.short_name}}</span>
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="defaultrate" label="參考" align="center">
              <template slot-scope="scope">
                <div class="phonecel">參考</div>
                <span>{{scope.row.defaultrate}}</span>
              </template>
            </el-table-column> -->
            <el-table-column prop="lasttime" label="最後更新" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">最後更新</div>
                <span>{{scope.row.lasttime}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <div class="phonecel">操作</div>
                <el-button size="mini" @click="edit0(scope.row)">修改</el-button>
              </template>

            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="mm-tabs-content">
        <div class="mm-tab-hedaer">
          <div class="mm-tab-title">
            <h3>匯款</h3>
          </div>

        </div>
        <div class="pagetablebox">
          <el-table empty-text="暫無數據" :data="ratedata1" border :header-cell-style="{background:'#FAFAFA'}">
            <el-table-column prop="name" label="貨幣" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">貨幣</div>
                <div style="display: flex; align-items: center; ">
                  <div><img style="display: block; width: 30px; height: 30px;" :src="apiurl+scope.row.thumb"></div>
                  <div style="margin-left: 10px;">{{scope.row.short_name}}</div>
                  <div style="margin-left: 10px;">{{scope.row.name}}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="buyrate" label="買入" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">買入</div>
                <span>{{scope.row.buyrate}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="sellrate" label="賣出" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">賣出</div>
                <span>{{scope.row.sellrate}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="costrate" label="成本" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">成本</div>
                <span>{{scope.row.costrate}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="fee" label="手續費" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">手續費</div>
                <div>
                  <span>{{scope.row.fee}}</span>
                  <span style="margin-left:10px" v-if="scope.row.fee!=''&&scope.row.fee!=null">{{scope.row.fee_type==1?'HKD':scope.row.short_name}}</span>
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="defaultrate" label="參考" align="center">
              <template slot-scope="scope">
                <div class="phonecel">參考</div>
                <span>{{scope.row.defaultrate}}</span>
              </template>
            </el-table-column> -->
            <el-table-column prop="lasttime" label="最後更新" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">最後更新</div>
                <span>{{scope.row.lasttime}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <div class="phonecel">操作</div>
                <el-button size="mini" @click="edit1(scope.row)">修改</el-button>
              </template>

            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {

  data () {
    return {
      mso_id:0,
      loading: false,
      store_id: 0,
      stores: [],
      ratedata0: [],
      ratedata1: [],
      transform: '',
      transformnum: 0,
    }
  },
  methods: {
    tableft () {
      let num = this.transformnum - 1;
      if (num >= 0) {
        this.transform = 'transform:translate3d(' + (-85 * num) + 'px,0,0)';
        this.transformnum = num;
      }

    },
    tabright () {
      let num = this.transformnum + 1;
      if (num < this.stores.length - 1) {
        this.transform = 'transform:translate3d(' + (-85 * num) + 'px,0,0)';
        this.transformnum = num;
      }
    },
    edit0 (row) {
      this.$router.push({
        name: '/EditRate',
        path: '/EditRate',
        params: {
          row: row
        }
      })
    },
    getrate0 () {
      this.loading = true;
      this.post('/api/rate/getrate', {
        store_id: this.store_id,
        type0: 0
      }).then((res) => {
        if (res.length > 0) {
          res = res.filter(item => {
            if (item.short_name != 'HKD') {
              return true;
            }
          })
        }
        this.ratedata0 = res;
        this.loading = false;

      }).catch((err) => {
        this.ratedata0 = [];
        this.loading = false;
        console.log(err)
      }).then(() => {

      })
    },
    edit1 (row) {
      this.$router.push({
        name: '/EditRate',
        path: '/EditRate',
        params: {
          row: row
        }
      })
    },
    getrate1 () {
      this.loading = true;
      this.post('/api/rate/getrate', {
        store_id: this.store_id,
        type0: 1
      }).then((res) => {
        if (res.length > 0) {
          res = res.filter(item => {
            if (item.short_name != 'HKD') {
              return true;
            }
          })
        }
        this.ratedata1 = res;
        this.loading = false;
      }).catch((err) => {
        this.ratedata1 = [];
        this.loading = false;
        console.log(err)
      }).then(() => {

      })
    },

    changestore (store_id) {
      this.store_id = store_id;
      this.sessionWrite('tab_rate_store_id', store_id);
      this.getrate0();
      this.getrate1();
    },

    gotoruter (name) {
      this.$router.push(name)
    },
    getstore () {
      this.loading = true;
      this.post('/api/rate/getstore', {

      }).then((res) => {
        this.stores = res;
        this.loading = false;

      }).catch((err) => {
        this.loading = false;
        console.log(err)
      }).then(() => {
        this.getrate0();
        this.getrate1();
      })


    }

  },
  created () {
    this.mso_id = this.sessionRead('mso_id');
    let store_id = this.sessionRead('tab_rate_store_id') || 0;
    this.store_id = store_id;
    this.getstore();
  }
}
</script>

<style scoped>
</style>
